import { combineReducers } from "@reduxjs/toolkit";
import { authReducer, slugReducer, userReducer } from "../slices";
import { scopeStackApi } from "../services/ScopeStackAPI";
import { scopeStackApiV2 } from "../services/ScopeStackAPIV2";

const rootReducer = combineReducers({
  [scopeStackApi.reducerPath]: scopeStackApi.reducer,
  [scopeStackApiV2.reducerPath]: scopeStackApiV2.reducer,
  auth: authReducer,
  slug: slugReducer,
  user: userReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
